import { render, staticRenderFns } from "./zzdhDetail.vue?vue&type=template&id=ec2899f4&scoped=true&"
import script from "./zzdhDetail.vue?vue&type=script&lang=js&"
export * from "./zzdhDetail.vue?vue&type=script&lang=js&"
import style0 from "./zzdhDetail.vue?vue&type=style&index=0&id=ec2899f4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2899f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec2899f4')) {
      api.createRecord('ec2899f4', component.options)
    } else {
      api.reload('ec2899f4', component.options)
    }
    module.hot.accept("./zzdhDetail.vue?vue&type=template&id=ec2899f4&scoped=true&", function () {
      api.rerender('ec2899f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/granary/map/util/zzdhDetail.vue"
export default component.exports